import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit';
import {HOSTNAME, LargeDataAnalyticsHostname} from "../configs/Domain";



export const fetchTimeSeriesData = createAsyncThunk(
    'timeSeries/fetchTimeSeriesData',
    async({symbols, startDate, endDate}, { getState, rejectWithValue})=>{
      const url = `${HOSTNAME}/timeseries/fetch?symbols=${symbols.join(',')}&sd=${startDate}&ed=${endDate}`;
      try{
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        console.log(data)
        return { data };
      } catch (error) {
        return rejectWithValue(error.toString());
      }
    }
)



export const getTimeSeriesMetric = createAsyncThunk(
    'timeSeries/getTimeSeriesMetric',
    async({symbols, targetSymbol, startDate, endDate, metric, window}, { getState, rejectWithValue})=>{
      let url = `${LargeDataAnalyticsHostname}/metrics/relative/${metric}?`;
      url += `features=${symbols.join(',')}&`;
      url += `target=${targetSymbol}&`;
      if (startDate) url += `start_date=${startDate}`;
      if (endDate) url += `&end_date=${endDate}`;
      if (window) url += `&window=${window}`;

      try{
        const response = await fetch(url);
        if (!response.ok) throw new Error('Network response was not ok');
        const data = await response.json();
        return data;
      } catch (error) {
        return rejectWithValue(error.toString());
      }
    }
)





export const fetchSimulationData = createAsyncThunk(
  'simulations/fetchData',
  async ({ modelName, symbols, endDate, nTrials, nSteps, nSamples, startDate='2018-01-01' }, { rejectWithValue }) => {
    try {
      // Construct the URL with query parameters
      let url = `${LargeDataAnalyticsHostname}/simulations/${modelName}?`;
      url += `symbols=${encodeURIComponent(symbols.join(','))}&`;
      url += `sd=${startDate}&`;
      url += `ed=${endDate}&`;
      url += `n_trials=${nTrials}&`;
      url += `n_steps=${nSteps}&`;
      url += `n_samples=${nSamples}`;

      // Use fetch or any other HTTP client that you prefer
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return { modelName, data };
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);


export const getHierarchicalAttribution = createAsyncThunk(
  'simulations/getHierarchicalAttribution',
  async ({ symbol, endDate, startDate='2018-01-01' }, { rejectWithValue }) => {
      console.log('CALLED HERE')
    try {
      // Construct the URL with query parameters
      let url = `${LargeDataAnalyticsHostname}/analysis/attribution/hierarchical?`;
      url += `symbol=${encodeURIComponent(symbol)}&`;
      url += `sd=${startDate}&`;
      url += `ed=${endDate}&`;

      // Use fetch or any other HTTP client that you prefer
      const response = await fetch(url);
      console.log(response)
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return {  data };
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);




export const getSimulationV2 = createAsyncThunk(
  'simulations/getSimulationV2',
  async ({
    years,
    timeStepsPerYear,
    initialValue,
    nPaths,
    targetAnnualReturn,
    targetAnnualVolatility,
    events,
    nSamples,
    lowerPercentile,
    upperPercentile
  }, { rejectWithValue }) => {
    try {
      const url = `${LargeDataAnalyticsHostname}/simulations/`;

      const body = {
        years,
        time_steps_per_year: timeStepsPerYear,
        initial_value: initialValue,
        n_paths: nPaths,
        target_annual_return: targetAnnualReturn,
        target_annual_volatility: targetAnnualVolatility,
        events,
        n_samples: nSamples,
        lower_percentile: lowerPercentile,
        upper_percentile: upperPercentile
      };

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);



export const fetchBlendedTimeseries = createAsyncThunk(
  'timeSeries/fetchBlended',
  async ({ mapping }, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams({ mapping }).toString();
      const url = `${HOSTNAME}/timeseries/blend?${params}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.toString());
    }
  }
);
/**
 * fetchBlendedTimeseriesV2
 *
 * A Redux Thunk action to fetch blended time series data from the server.
 * This function accepts an array of key-value objects (`mapping`) and sends it via a POST request.
 *
 * The server expects an array of objects formatted as:
 * [
 *   { "k": "key1", "v": "value1" },
 *   { "k": "key2", "v": "value2" },
 *   ...
 * ]
 *
 * Example Usage:
 * dispatch(fetchBlendedTimeseriesV2({ mapping: [{ k: "AAPL", v: "SPY" }, { k: "TSLA", v: "QQQ" }] }));
 */

export const fetchBlendedTimeseriesV2 = createAsyncThunk(
  'timeSeries/fetchBlendedV2',
  async ({ mapping, startDate }, { rejectWithValue }) => {
    try {
      // Validate the input to ensure 'mapping' is an array of objects containing 'k' and 'v' properties
      if (!Array.isArray(mapping) || !mapping.every(obj => obj.k && obj.v)) {
        throw new Error('Invalid mapping format: Expected an array of objects with "k" and "v" properties.');
      }

      // Define the URL for the API endpoint
      const url = `${HOSTNAME}/timeseries/blend/v2`;
      const payload = { mapping }
      if (startDate){
          payload.sd = startDate;
      }

      // Prepare the POST request options
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      };

      // Fetch data from the server
      const response = await fetch(url, requestOptions);

      console.log(response);

      // Check if the response was successful
      if (!response.ok) throw new Error('Network response was not ok');

      // Parse the JSON data from the response
      const data = await response.json();
      return data;
    } catch (error) {
      // Handle any errors that occur during the fetch operation
      return rejectWithValue(error.toString());
    }
  }
);


export const fetchCompositeRelativeMetric = createAsyncThunk(
  'portfolios/fetchCompositeRelativeMetric',
  async ({ portfolioId, metricName = 'beta', window = 252 }, { getState, rejectWithValue }) => {
    try {
      // Generate the unique key for checking existing data
      const key = `${portfolioId}_${metricName}_${window}`;
      // Construct the URL with query parameters
      const url = `${LargeDataAnalyticsHostname}/portfolios/${portfolioId}/composite/relative?metric_name=${metricName}&window=${window}`;

      // Fetch data from the server
      const response = await fetch(url);


      // Check if the response was successful
      if (!response.ok) throw new Error('Network response was not ok');

      // Parse the JSON data from the response
      const data = await response.json();
      console.log("RESPONSE ", data)
      return data;
    } catch (error) {
      // Handle any errors that occur during the fetch operation
      return rejectWithValue(error.toString());
    }
  }
);